import React, {FC} from 'react'
import {useFormContext, Controller} from 'react-hook-form'
type InputProps = {
  name: string
  onChange?: (e: any) => void
  minValue?: string
  disabled?: boolean
  readOnly?: boolean
  maxValue?: string
}

const InputHour: FC<InputProps> = ({
  name,
  onChange,
  minValue = '1999-01-01',
  maxValue = '3999-01-01',
  disabled = false,
  readOnly = false,
  ...props
}) => {
  const {
    control,
    formState: {errors},
  } = useFormContext()
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: {onChange: (value: string) => void},
  ) => {
    let value = e.target.value
    if (onChange) {
      onChange(e)
    }

    field.onChange(value)
  }

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <input
            type='time'
            className='form-control sdx-centra-input-form'
            {...field}
            style={{backgroundColor: readOnly || disabled ? '#f5f5f5' : 'white'}}
            disabled={disabled}
            readOnly={readOnly}
            min={minValue ? minValue : '1999-01-01'}
            max={maxValue ? maxValue : '3999-01-01'}
            onChange={(e) => handleChange(e, field)}
          />
        )}
      />

      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputHour
